import { useCallback, useEffect, useState, type FormEvent } from 'react'
import { getPortaria, postPortaria, type Area } from './portariaApi'

type Blackout = { id: string; startsAt: string; endsAt: string; reason: string }
const dateText = (value: string) => new Date(value).toLocaleString('pt-BR')

export function AreaBlackouts({ clientId, area, canManage, onClose }: {
  clientId: string; area: Area; canManage: boolean; onClose: () => void
}) {
  const [items, setItems] = useState<Blackout[]>([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const load = useCallback(async () => {
    const result = await getPortaria<Blackout[]>(clientId, `areas/${area.id}/blackouts`)
    setItems(result)
  }, [clientId, area.id])

  useEffect(() => { void load().catch(() => setError('Não foi possível carregar os períodos bloqueados.')) }, [load])

  async function create(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = event.currentTarget
    const data = new FormData(form)
    setBusy(true); setError(''); setMessage('')
    try {
      await postPortaria(clientId, `areas/${area.id}/blackouts`, {
        startsAt: new Date(String(data.get('startsAt'))).toISOString(),
        endsAt: new Date(String(data.get('endsAt'))).toISOString(),
        reason: String(data.get('reason') ?? '').trim(),
      })
      await load(); form.reset(); setMessage('Período bloqueado.')
    } catch { setError('Não foi possível bloquear: confira as datas e se já há uma reserva nesse período.') }
    finally { setBusy(false) }
  }

  async function cancel(id: string) {
    setBusy(true); setError(''); setMessage('')
    try {
      await postPortaria(clientId, `areas/${area.id}/blackouts/${id}/cancel`)
      await load(); setMessage('Bloqueio cancelado.')
    } catch { setError('Não foi possível cancelar o bloqueio.') }
    finally { setBusy(false) }
  }

  return <div className="portaria-modal-backdrop"><div className="portaria-modal" role="dialog" aria-modal="true" aria-label={`Bloqueios de ${area.name}`}>
    <h2>Períodos bloqueados · {area.name}</h2>
    <p>Use para manutenção, eventos internos ou fechamento da área. Reservas já existentes impedem um bloqueio conflitante.</p>
    {error && <div className="portaria-error" role="alert">{error}</div>}
    {message && <div className="portaria-success" role="status">{message}</div>}
    {canManage && <form className="portaria-form-grid" onSubmit={event => void create(event)}>
      <label>Início<input name="startsAt" type="datetime-local" required /></label>
      <label>Fim<input name="endsAt" type="datetime-local" required /></label>
      <label>Motivo<input name="reason" maxLength={240} required /></label>
      <button disabled={busy}>Bloquear período</button>
    </form>}
    <div className="portaria-list">{items.length ? items.map(item => <div key={item.id}>
      <strong>{dateText(item.startsAt)} até {dateText(item.endsAt)}</strong><small>{item.reason}</small>
      {canManage && <button type="button" disabled={busy} onClick={() => void cancel(item.id)}>Cancelar bloqueio</button>}
    </div>) : <p>Nenhum período bloqueado.</p>}</div>
    <div className="portaria-actions"><button type="button" className="portaria-quiet" onClick={onClose}>Fechar</button></div>
  </div></div>
}
